import {z}from'zod';const r=z.object({price:z.number().nullable(),maxDistance:z.number().nullable(),hours:z.number()});export{r as AttendantPriceSchema};